import "./ElGalle.css"

function ElGalle(){
    return(
        <>
        <div className="padreInfoGalle" >
            <div className="logoContainer">
            </div>
            <div className="infoElGalle">
                <h1 className="elGalleTitle">¿Quiénes Somos?</h1>
                <p>
                Somos una empresa dedicada a los alimentos saludables con más de
                diez años de experiencia. Comenzamos ofreciendo mix de frutos secos
                y granolas al por mayor, y con el tiempo fuimos ampliando nuestra
                propuesta.
                </p>

                <p>
                Hace cinco años dimos el paso hacia la venta minorista, abriendo
                nuestro local y sumando cereales, semillas, harinas y productos de
                repostería.
                </p>

                <p>
                Hoy, luego de una década de recorrido, nos modernizamos y adoptamos
                un modelo de ventas 100% online, manteniendo lo que siempre nos
                definió: productos de calidad, precios justos y envíos directos a tu
                hogar.
                </p>    
            </div>
            <div className="infoElGalle metaInfo">
                <h2 className="metaTitle">Información institucional</h2>

                <p>
                El Galle mantiene su plataforma en colaboración con <strong>TecnoDev</strong>.
                TecnoDev es responsable de la gestión y el mantenimiento de todos
                los servicios digitales, garantizando el correcto funcionamiento,
                la seguridad y la evolución tecnológica de la plataforma.
                </p>

                <p>
                Esta alianza garantiza una experiencia segura, moderna y confiable
                para nuestros clientes en todos nuestros canales digitales.
                </p>
            </div>
        </div>
        </>
    )
}

export default ElGalle